var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","fab":"","color":"white"},on:{"click":_vm.goBack}},[_c('v-icon',{staticClass:"back-button-icon",attrs:{"x-large":""}},[_vm._v("fal fa-arrow-circle-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }